const storage = {};

export const loadQuestions = async locale => {
  if (!storage[locale]) {
    try {
      const response = await fetch(`/assets/questions_${locale}.json`);
      if (!response.ok) {
        throw new Error(`Failed to fetch questions for locale: ${locale}`);
      }
      const data = await response.json();

      storage[locale] = data;
      return data;
    } catch (error) {
      console.error(error);
    }
  } else {
    return storage[locale];
  }
};



// WEBPACK FOOTER //
// ./src/services/data.ts